export default __webpack_public_path__ + "static/media/agentFemale.f202154c.png";